import moment from "moment";
import { toWords } from "number-to-words";

const SCHOOL_SESSION_END = process.env.SCHOOL_SESSION_END || "04-01"; // MM-DD format

export const GetCurrentAcademciSession = () => {
  const currentYear = moment().year();
  const sessionEndDate = moment(
    `${currentYear}-${SCHOOL_SESSION_END}`,
    "YYYY-MM-DD"
  );
  const today = moment();

  if (today.isBefore(sessionEndDate)) {
    return `${currentYear - 1}-${currentYear}`;
  } else {
    return `${currentYear}-${currentYear + 1}`;
  }
};

export const getAcademicYearsList = () => {
  const currentSession = GetCurrentAcademciSession(); // Uses the function we defined earlier
  const [startYear, endYear] = currentSession.split("-").map(Number);

  return [
    // `${startYear - 1}-${endYear - 1}`, // Past academic year
    `${startYear}-${endYear}`, // Current academic year
    // `${startYear + 1}-${endYear + 1}`, // Next academic year
  ];
};

export const getPastAcademicYearsList = () => {
  const currentSession = GetCurrentAcademciSession(); // Uses the function we defined earlier
  const [startYear, endYear] = currentSession.split("-").map(Number);

  return [`${startYear}-${endYear}`, `${startYear - 1}-${endYear - 1}`];
};

export const dateToWords = (dateStr) => {
  const date = moment(dateStr, "DD-MM-YYYY");
  if (!date.isValid()) return "";

  const day = toWords(date.date()).toUpperCase(); // 25 -> TWENTY FIVE
  const month = date.format("MMMM").toUpperCase(); // May -> MAY
  const yearWords = date.year().toString().split("").map(Number);

  const yearNumber = date.year();
  const yearInWords = toWords(yearNumber).toUpperCase(); // 2008 -> TWO THOUSAND EIGHT

  return `${day} ${month} ${yearInWords.replace(",", "")}`;
};

export const extractClassLevel = (str) => {
  const romanToClass = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };

  const match = str.match(/^(I{1,3}|IV|V?I{0,3}|IX|X|XI{0,2}|XII)/); // Match Roman at start
  if (match) {
    const roman = match[0];
    const classNum = romanToClass[roman];
    if (classNum === 10) return "10th";
    if (classNum === 12) return "12th";
  }

  return null; // If not matched
};

export const generateSecurePassword = (length = 8) => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const digits = "0123456789";
  const special = "!@#$%^&*_=+?";
  const all = upper + lower + digits + special;

  const getRandom = (str) => str[Math.floor(Math.random() * str.length)];

  let password = [
    getRandom(upper),
    getRandom(lower),
    getRandom(digits),
    getRandom(special),
  ];

  while (password.length < length) {
    password.push(getRandom(all));
  }

  return password.sort(() => 0.5 - Math.random()).join("");
};
